module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "part",
      "id": "pt01"
    }
  }, [_c('h1', {
    staticClass: "pn"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "p19"
    }
  }), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chirapp0008#toc"
    }
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("PART")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("ONE")])])]), _vm._v(" "), _c('h1', {
    staticClass: "pt"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "data-locator": "p19"
    }
  }), _vm._v("Boys to Men")]), _vm._v(" "), _c('div', {
    staticClass: "epigraph"
  }, [_c('p', {
    staticClass: "epf"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "data-locator": "p19"
    }
  }), _vm._v("We need only realise our parents, remember our grandparents and know ourselves and our history is complete.")]), _vm._v(" "), _c('p', {
    staticClass: "ept"
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("GERTRUDE")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("STEIN,")]), _vm._v(" "), _c('i', [_vm._v("The Making of Americans")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02eb8d80","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chi-rapp-0012.vue
// module id = 87
// module chunks = 0